import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import Moment from 'moment';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';


import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import ReportHeader from "Routes/reportTemplate/header";
import ReportFooter from "Routes/reportTemplate/footer";
import ReportBGImage from "Routes/reportTemplate/watermark";

import {  
    allInjuryChart,
   getstudentinjurylist,
   fetchInjuryDetails
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';



class injurychartreport extends Component {
   
    constructor(props) {
        
        super(props);
        this.nodeRef = React.createRef();
            this.state = {
                viewdiv:true,
                succdiv:false,
                student:'',
                accordionContent:[],
                heightProportion: 1600,
                widthProportion: 0
            };  
        this.onBackSection = this.onBackSection.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.allInjuryChart();
	}
    
  updateDimensions() {
    if (!this.nodeRef || !this.nodeRef.current) return;

    const node = this.nodeRef.current;
    const nodewidth = node.offsetWidth;
    const nodeheight = node.offsetHeight;

    this.setState({
        widthProportion: nodewidth,
        // heightProportion: nodeheight, // uncomment if needed
    });
}


    

    selectquarter(evt){
        var selstudent=evt.value;
        if(selstudent!=''){
            this.setState({ student : selstudent});
            this.props.getstudentinjurylist(selstudent).then((data) => {   
                this.setState({ viewdiv : true});
            });
           
        }
    }

   addHandleReport(rowid) {
    this.props.fetchInjuryDetails(rowid).then((data) => {
        this.setState(
            { 
                viewdiv: false,
                errordiv: false,
                succdiv: true
            },
            () => { 
                // Callback after state update
                this.updateDimensions(); 
            }
        );
    });
}


    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	} 

    onBackSection() {
		this.setState({ 
            succdiv:false,
            maindiv:true,
            viewdiv:true,
         });
	}

    render() {
       const { match, injurychartlists, injuryfulldetails, injuryallupdates, loading } = this.props;
        
      

       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "date", label: "Date" },
            { name: "report", label: "Report" }
        ];
        const tabledata=injurychartlists.map((assmntval,idx) => {            
            
                const ebtn=<MatButton variant="contained" color="error" className="btn-icon btn-google mr-15 mb-10 text-white" onClick={ ()=>this.addHandleReport(assmntval.sicID)}> <i className="zmdi zmdi-file-text"></i> Report</MatButton>;
             
                return {
                no:idx+1,
                name: assmntval.student,
                date: assmntval.cdate,
                report: ebtn
                }
        });

        const formatDate = Moment(injuryfulldetails.sic_date).format('DD/MM/YYYY   hh:mm a');
        const uptcnt=injuryallupdates.length;
    
        const styles = {
            table: {
                border: "1px solid black",
                borderColor:"black",
                borderStyle:"solid",
                fontFamily: "Arial",            
                zIndex:"100"
            },
            tablelefthead:{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                width:"30%",
                fontWeight:"bold",
                fontSize:"18px"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                fontSize:"16px"
            },
            rctcontent:{
                borderRadius: "5px",
                boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
                border: "none",
                transition: "all 0.4s ease-in-out 0s",
                marginBottom: "24px",
                padding:"0px 20px 10px 20px",
                zIndex:"1"
    
            }
        };
       return (
          <div className="row">
             


                {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable                              
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
                } 

                {this.state.succdiv &&
                    <div className="row">
                        <div className="col-sm-12 col-md-6"> 
                        <div className="col-sm-12 col-md-12 clearfix">    
                            <div className="example-config clearfix" style={{zIndex:"10000"}}>

                                <button
                                className="mr-3 mb-3 btn btn-outline-warning float-right"
                                onClick={this.onBackSection}
                                >
                                Back
                                </button>
                            
                            </div>
                        </div>    
                            
                                <ReportHeader />
                                <div style={styles.rctcontent}>
                                    <ReportBGImage />                               
                                        <div className="reportdiv" style={{padding:"1.25rem 1.25rem", position:"relative"}}>
                                            <h1 className="text-center" style={{marginTop:"30px", marginBottom:"20px"}}> Injury Report</h1>
                                            <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                <tbody>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Name 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {injuryfulldetails.student}
                                                    </td>                                                   
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Date and Time
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {formatDate}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Age / Gender
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {injuryfulldetails.sic_age} / {injuryfulldetails.sic_gender==1?'Male':'Female'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Skill
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_skill}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Chief Complaint
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_chief_complaint}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Mechanism Of Injury
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_mechanism_injury}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    History of Present Injury
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_history_present_injury}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    History of Similar Injury in the Past
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_history_injury_past}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Clinical Assessment and Observations
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_observations_assessment}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Clinical Findings
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_clinical_findings}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Provisional Diagnosis
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_provisional_diagnosis}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Injury Severity
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_injury_severity}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Further Consultation (if any)
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_consultation_investigations}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Plan Of Action
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_plan_action}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Restrictions (if any)
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_restrictions}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Expected time for Return to Sports
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_return_sports}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Notes for S&C Team
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_sc_team}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Notes for Coaching Team
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                            {injuryfulldetails.sic_coaching_team}
                                                    </td>
                                                </tr>                                                
                                                </tbody>
                                            </table>
                                            <div className="col-md-12" style={{marginTop:"80px"}}>
                                                <p style={{fontSize:"20px"}}>{injuryfulldetails.sc_name}</p>
                                                <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{injuryfulldetails.sc_designation}</p>
                                                <p style={{marginTop:"20px",fontSize:"20px", fontWeight:"300"}}>{'{e}'} {injuryfulldetails.sc_email}</p>
                                                <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {injuryfulldetails.sc_phone}</p>
                                            </div>                                            
                                        </div>
                                    <ReportFooter />       
                                </div> 
                           
                        </div> 
                        { uptcnt!=0 ? (
                        <div className="col-sm-12 col-md-6" ref={this.nodeRef}>
                            <CarouselProvider                            
                                naturalSlideWidth={this.state.widthProportion}
                                naturalSlideHeight={this.state.heightProportion}
                                totalSlides={uptcnt}
                                >
                            <div className="sdfsdf">
                                <ButtonBack className="mr-3 mb-3 btn btn-outline-primary">Prev</ButtonBack>
                                <ButtonNext className="mr-3 mb-3 btn btn-outline-primary float-right">Next</ButtonNext>
                                <div className="text-center" style={{marginTop:"-30px"}}>
                                    {injuryallupdates.map((uptval,idx) => ( 
                                        <Dot className="text-center" slide={idx} >{idx+1}</Dot>
                                    ))}
                                </div>                        
                            </div>
                            <Slider>    
                            
                            {injuryallupdates.map((uptval,idx) => (                                  
                                    <Slide index={idx}> 
                                    <ReportHeader />
                                    <div style={styles.rctcontent}>                                             
                                        <div className="collapse show">
                                            <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>                                                
                                                <div className="row justify-content-center reportdiv">
                                                    <ReportBGImage />
                                                    <h1 className="text-center" style={{marginTop:"30px", marginBottom:"20px"}}> Injury Update</h1>
                                                    <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                        <tbody>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Name 
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injuryfulldetails.student}
                                                            </td>                                                   
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Date and Time
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                            {Moment(uptval.siu_date).format('DD/MM/YYYY   hh:mm a')} 
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Age / Gender
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injuryfulldetails.sic_age} / {injuryfulldetails.sic_gender==1?'Male':'Female'}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Provisional Diagnosis
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_provisional_diagnosis}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Injury Severity
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_injury_severity}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Update on Rehabilitation
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_update_rehabilitation}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Plan Of Action
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_plan_action}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Note for S&C Team
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_note_sc_team}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Note for Coaching Team
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_note_coaching_team}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Note for Team TSG
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {uptval.siu_note_tsg_team}
                                                            </td>
                                                        </tr>
                                                        
                                                        
                                                        </tbody>
                                                    </table>
                                                    <div className="col-md-12" style={{marginTop:"80px"}}>
                                                        <p style={{fontSize:"20px"}}>{uptval.sc_name}</p>
                                                        <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{uptval.sc_designation}</p>
                                                        <p style={{marginTop:"20px",fontSize:"20px", fontWeight:"300"}}>{'{e}'} {uptval.sc_email}</p>
                                                        <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {uptval.sc_phone}</p>
                                                    </div>                                            
                                                </div>
                                            </div>
                                        </div>  
                                        <ReportFooter />       
                                    </div>                                
                                </Slide>
                                                            
                            ))}
                            </Slider>
                        
                        </CarouselProvider>
                        </div>
                        ):(" ")
                        }
                      
                    </div>
                } 
               
            
          </div>
       )
    }
 }




const mapStateToProps = ({ injurychart  }) => {
    const { injurychartlists, injuryfulldetails, injuryallupdates, loading } = injurychart;
	return {  injurychartlists, injuryfulldetails, injuryallupdates, loading };
}

export default connect(mapStateToProps, {
    allInjuryChart,
    getstudentinjurylist,
    fetchInjuryDetails
})(injurychartreport); 